import {
  compile
} from 'handlebars';
import {
  delay
} from 'lodash';
import Core from '../../lib/Core';
import {
  formatDateTime12hPT
} from '../../lib/Date.lib';
import {
  Fun
} from '../../lib/Function.lib';
import useState from '../../lib/hooks/useState.hook';
import {
  sendSafeEmail
} from '../../lib/services/Email/Email.lib';
import {
  compileText
} from '../../lib/String.lib';
import {
  HTML__CURRENT__ENGAMENT_TERMS,
  TEMPLATE__BODY__USER_AGREED_ENGAGEMENTS_TERMS,
  TEMPLATE__SUBJECT__USER_AGREED_ENGAGEMENTS_TERMS,
  VERSION__CURRENT__ENGAGEMENTS_TERMS
} from '../../lib/templates/CollectionUserAgreeToTerms.template';
import {
  getPathname
} from '../../lib/URL.lib';
import {
  hideConfirm,
  showConfirm
} from '../Dialogs/AppConfirmationDialog';
import {
  noUserAgreeToEngagementsTerms,
  setUserAgreeToEngagementsTerms,
  unsetUserAgreeToEngagementsTerms,
  yesUserAgreeToEngagementsTerms
} from './Libraries/UserAgreeEngagementsTerms.lib';
import Box from '../Layout/Wrappers/Box';
import Checkbox from '../Layout/Wrappers/Checkbox';
import {
  Html
} from '../Layout/Wrappers/Html';
import Typography, {
  Label
} from '../Layout/Wrappers/Typography';

export default function AggreementEngagementsTerms({
  onAccept = Fun
}) {
  const [state, updateState] = useState();
  const YES__USER_AGREE_TO_TERMS = yesUserAgreeToEngagementsTerms();
  const NOT__USER_AGREE_TO_TERMS = noUserAgreeToEngagementsTerms();
  return (
    <Box column className='bg-white p-1'>
      <Label className='tt-none'>
        Confirmation Required
      </Label>
      <Typography sub>
        Please confirm you understand and agree to the following:
      </Typography>
      <Html
        className='p-1 bold-darker'
        style={{ maxWidth: 640 }}
        value={HTML__CURRENT__ENGAMENT_TERMS}
      />
      <Box row className='mt-1'>
        <Checkbox
          checked={state.yesUserAgreeToTerms || YES__USER_AGREE_TO_TERMS}
          onChange={async (event, value) => {
            await updateState({ yesUserAgreeToTerms: value });
            delay(async () => {
              hideConfirm();
              if (value === true) {
                const VALUE__USER__NAME = Core.getUserName() || '[user name]';
                const VALUE__USER__EMAIL = Core.getUser().email || '[user email]';
                sendSafeEmail({
                  to: process.env.REACT_APP_TEAM_EMAIL,
                  subject: compileText(TEMPLATE__SUBJECT__USER_AGREED_ENGAGEMENTS_TERMS, {
                    USER__NAME: VALUE__USER__NAME,
                    TERMS__VERSION: VERSION__CURRENT__ENGAGEMENTS_TERMS
                  }),
                  html: compile(TEMPLATE__BODY__USER_AGREED_ENGAGEMENTS_TERMS)({
                    USER__ID: Core.getUser().id || '[user id]',
                    USER__NAME: VALUE__USER__NAME || '[user name]',
                    USER__EMAIL: VALUE__USER__EMAIL || '[user email]',
                    USER__PHONE: Core.getUser().phone || '[user phone]',
                    USER__AGENCY__NAME: Core.getUser().employerName || '[user agency name]',
                    PAGE__NAME: getPathname() || '/',
                    TIMESTAMP__ACCEPTED__DATE_TIME__UTC: formatDateTime12hPT(
                      Date.now(), { seconds: true }
                    ),
                    IP__ADDRESS: await Core.getIP() || '[user ip address: unknown]',
                    TERMS__VERSION: VERSION__CURRENT__ENGAGEMENTS_TERMS,
                    TERMS__HTML: HTML__CURRENT__ENGAMENT_TERMS
                  })
                });
                setUserAgreeToEngagementsTerms(true);
              }
              else {
                unsetUserAgreeToEngagementsTerms();
              }
              await updateState(); // force local re-render, for drawer
              onAccept();
            }, 100);
          }}
          label='Yes, I agree'
        />
        <Checkbox
          checked={state.notUserAgreeToTerms || NOT__USER_AGREE_TO_TERMS}
          onChange={async (event, value) => {
            await updateState({ notUserAgreeToTerms: value });
            delay(async () => {
              hideConfirm();
              if (value === true) {
                setUserAgreeToEngagementsTerms(false);
                Core.closeDrawer();
              }
              else {
                unsetUserAgreeToEngagementsTerms();
                updateState(); // force local re-render, for drawer
              }
            }, 100);
          }}
          label='No, take me back'
        />
      </Box>
    </Box>
  );
}

export async function openDialogUserAgreeEngagementsTerms(props) {
  showConfirm({
    message: <AggreementEngagementsTerms {...props} />,
    displayActions: false
  });
}
